<template>
    <section>
        <div class="col">
            <div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input
                            v-for="(ip, key) in ip_list"
                            type="text"
                            dir="ltr"
                            class="form-control mb-2"
                            placeholder="185.10.10.1"
                            :id="'title' + key"
                            :name="'title' + key"
                            :key="key"
                            v-model="ip_list[key]"
                        />
                    </div>
                </div>
                <div class="col-12 my-2">
                    <button class="btn btn-danger mr-2 px-2 text-center"
                            type="button"
                            @click="removeIp()"
                            :disabled="ip_list.length <= 1"
                    >
                        <i class="text-center px-2 fas fa-minus"></i>
                    </button>
                    <button class="btn btn-primary mx-auto px-2 text-center"
                            type="button"
                            @click="addIp()"
                            :disabled="cannotAddMoreIps"
                    >
                        <i class="text-center mx-auto px-2 fas fa-plus"></i>
                    </button>
                </div>
                <p class="font-weight-bold">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#F19E39"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                    <span>
              حداکثر تعداد آی پی مجز مجاز {{ips_max_count}} عدد است.
              </span>
                </p>
                <button disabled v-if="progress" class="btn btn-success">
                    لطفا صبر کنید
                </button>
                <button
                    v-if="!progress"
                    class="btn btn-success"
                    @click="updateIps"
                    :disabled="!ip_list.some(ip => ip && ip.trim())"
                >
                    {{ $t('btn.update') }}
                </button>
            </div>
        </div>
    </section>
</template>

<script>
import { enamadServices, gatewayService } from '@/common/api.service';
import { BASE_PATH } from '@/common/config';
import enamadSuccess from '@/pages/enamad/paymentRedirect/enamadSuccess.vue';
import toastr from 'toastr';
import { i18n } from '@/plugins/i18n';

export default {
    name: 'gateway-ips',
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: 'toast-bottom-center',
                preventDuplicates: false,
                rtl: false
            };

            return toastr;
        },
        cannotAddMoreIps() {
            return this.ip_list.length >= this.ips_max_count;
        },
    },
    data() {
        return {
            progress: false,
            ips_max_count: 3,
            // Local copy: the prop is replaced whenever the gateway data reloads.
            ip_list: [''],
        };
    },
    props: {
        ips: {
            type: Array,
            default: null,
        }
    },
    methods: {
        updateIps() {
            const ips = this.ip_list.map((ip) => (ip || '').trim()).filter((ip) => ip)
            this.progress = true;
            gatewayService
                .updateAllowedIps(this.$route.params.hashid, ips)
                .then(({ data }) => {
                    this.ip_list = ips.length ? ips : ['']
                    this.toastr.success(data.message);
                })
                .catch(({ response }) => {
                    const body = (response && response.data) || {}
                    const errors = body.data && typeof body.data === 'object' ? Object.values(body.data).flat() : []
                    this.toastr.error(errors[0] || body.message);
                })
                .finally(() => {
                    this.progress = false;
                });
        },
        addIp() {
            if (this.ip_list.length >= this.ips_max_count) {
                return;
            }

            this.ip_list.push('');
        },
        removeIp() {
            if (this.ip_list.length === 1) {
                return;
            }

            this.ip_list.pop();
        },
    },
    watch: {
        ips: {
            immediate: true,
            handler(ips) {
                this.ip_list = ips && ips.length ? [...ips] : [''];
            },
        },
    },
    beforeMount() {
    },
    mounted() {
    }
};
</script>

<style scoped></style>
